import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 rounded-full peer transition duration-100 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-gray-800 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-300 dark:peer-checked:bg-primary-400" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "relative inline-flex items-center mr-5 cursor-pointer",
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.soundEffects('switch')))
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      class: "sr-only peer",
      checked: _ctx.checked
    }, null, 8, _hoisted_1),
    _hoisted_2
  ], 32))
}